import React, { useMemo } from 'react';

import TypeAResult from 'modules/type-a-quiz-result';
import useQuizResultInformation from 'hooks/useQuizResultInformation';
import {
  TYPE_A_CHANGE_EMAIL_BUTTON_TEXT,
  TYPE_A_GO_TO_APP_BUTTON_TEXT,
  TYPE_A_RESULT_TEXT,
  TYPE_A_SUGGESTION_TEXT,
} from './constants';
import { QUIZ_RESULT_SECTION_ID } from 'modules/quiz-result';
import FranticTopSection from 'modules/frantic-top-section';
import TypeAChallengeMap from 'modules/type-a-quiz-result/challenge-map';
import { TypeAResults } from 'modules/type-a-quiz/results';

type FranticQuizResultProps = {
  quizResultSectionRef: React.MutableRefObject<HTMLDivElement | null>;
};

const FranticQuizResult = ({
  quizResultSectionRef,
}: FranticQuizResultProps) => {
  const [
    email,
    name,
    resultInformation,
    onNavBarButtonClick,
  ] = useQuizResultInformation(TypeAChallengeMap, TypeAResults.SPARK);
  const existingUserText = useMemo(
    () =>
      `Hello, ${name}, your current email is ${email}, continue your journey?`,
    [email, name],
  );

  return (
    <TypeAResult
      quizResultSectionRef={quizResultSectionRef}
      resultText={TYPE_A_RESULT_TEXT(resultInformation.title)}
      suggestion={TYPE_A_SUGGESTION_TEXT}
      challengeImage={resultInformation.image}
      challengeTitle={resultInformation.title}
      challengeSubtitle={resultInformation.subtitle}
      description={TYPE_A_SUGGESTION_TEXT}
      existingUserText={existingUserText}
      goToAppButtonText={TYPE_A_GO_TO_APP_BUTTON_TEXT}
      changeEmailButtonText={TYPE_A_CHANGE_EMAIL_BUTTON_TEXT}
      email={email}>
      <FranticTopSection
        onNavBarButtonClick={onNavBarButtonClick}
        navBarButtonText="Retake the Quiz"
        mainButtonHrefId={QUIZ_RESULT_SECTION_ID}
      />
    </TypeAResult>
  );
};

export default FranticQuizResult;
